export default function mergeClassNames(...classes: [string, string]) {
  return classes.filter(Boolean).join(" ");
}
